define('core/pluralize',["exports", "deps/pluralize", "core/utils"], function (exports, _pluralize, _utils) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.name = undefined;
  exports.run = run;
  // Adds automatic pluralization to dfns
  // If a dfn is referenced as it's plural (and plural of `data-lt` attributes),
  //   plurals of it are automatically added to `data-plurals`.
  // The linking is done in core/link-to-dfn

  const name = exports.name = "core/pluralize";

  function run(conf) {
    if (!conf.pluralize) return;

    const pluralizeDfn = getPluralizer();

    document.querySelectorAll("dfn:not([data-lt-no-plural]):not([data-lt-noDefault])").forEach(dfn => {
      const terms = [dfn.textContent];
      if (dfn.dataset.lt) terms.push(...dfn.dataset.lt.split("|"));

      const plurals = Array.from(terms.map(pluralizeDfn).filter(plural => plural).reduce((plurals, plural) => plurals.add(plural), new Set()));

      if (plurals.length) {
        const userDefinedPlurals = dfn.dataset.plurals ? dfn.dataset.plurals.split("|") : [];
        const uniquePlurals = [...new Set([...userDefinedPlurals, ...plurals])];
        dfn.dataset.plurals = uniquePlurals.join("|");
        uniquePlurals.reduce((defMap, plural) => {
          if (!defMap[plural]) defMap[plural] = [];
          defMap[plural].push($(dfn));
          return defMap;
        }, conf.definitionMap);
      }
    });
  }

  function getPluralizer() {
    const links = new Set();
    document.querySelectorAll("a:not([href])").forEach(el => {
      const normText = (0, _utils.norm)(el.textContent).toLowerCase();
      links.add(normText);
      if (el.dataset.lt) {
        links.add(el.dataset.lt);
      }
    });

    const dfns = new Set();
    document.querySelectorAll("dfn:not([data-lt-noDefault])").forEach(dfn => {
      const normText = (0, _utils.norm)(dfn.textContent).toLowerCase();
      dfns.add(normText);
      if (dfn.dataset.lt) {
        dfn.dataset.lt.split("|").reduce((dfns, lt) => dfns.add(lt), dfns);
      }
    });

    // returns pluralized term if `text` needs pluralization, "" otherwise
    return function pluralizeDfn(text) {
      const normText = (0, _utils.norm)(text.toLowerCase());
      const plural = (0, _pluralize.plural)(normText);
      return links.has(plural) && !dfns.has(plural) ? plural : "";
    };
  }
});
//# sourceMappingURL=pluralize.js.map;
